<script setup>
    
    defineProps({
        whiteSteps: {
            type: Number,
            default: 1
        }
    })
</script>
<template>
    <div class="constructor__header">
        <h3 class="title3" > <slot name="title"></slot> </h3>
        <ul class="constructor__steps">
            <li v-for="step, index in 6" :class="['constructor__step', { '--white': index < whiteSteps }]"></li>
        </ul>
        <p class="constructor__text"> <slot name="text"></slot> </p>
    </div>
</template>
<style lang='scss' scoped>
</style>